import HttpClient from "utils/HttpClient/HttpClient"
import { LOGIN_SUCCESSFUL, SUCCESSFUL_GET_USER_INFO } from "./actionConst";
import { SHOW_ERROR_MESSAGE, SHOW_SUCCESSFUL_MESSAGE, LOGGED_IN_MESSAGE } from 'reducers/application/actionConst';
import { AUTHENTICATED_HOME, NOT_AUTHENTICATED_HOME } from 'routes/routesConstants';
import Auth from "utils/Auth/Auth";
import history from 'utils/History/history';

export const login = (credentials) => dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    var qs = require('qs');
    new HttpClient(false).post("b2c/login", qs.stringify(credentials), config)
        .then((response) => {
            console.log("Login Successful");
            let payload = {
                user: response.data,
                token: response.headers.authorization
            }
            let auth = new Auth();
            auth.setAuthData(payload);
            dispatch({ type: LOGIN_SUCCESSFUL, payload: payload });
            dispatch({ type: LOGGED_IN_MESSAGE, payload: true });
            history.replace(AUTHENTICATED_HOME);
        })
        .catch((error) => {
            console.log("enter here error login request");
            dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Error al iniciar sesión" });
        })
}

export const fetchUserInfo = () => dispatch => {
    new HttpClient(true).get("b2c/user")
        .then((response) => {
            console.log("Successful Fetch User");
            dispatch({
                type: SUCCESSFUL_GET_USER_INFO,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch User");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        })
}

export const resetPassword = (data, userName) => dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    new HttpClient(false).post("b2c/reset-password", data, config)
        .then((response) => {
            dispatch({ type: SHOW_SUCCESSFUL_MESSAGE, payload: "Contraseña establecida correctamente. Por favor iniciar sesión." });
            history.replace(NOT_AUTHENTICATED_HOME + "?username=" + userName);
        })
        .catch((error) => {
            dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
        })
}

export const recoverPassword = (email) => dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    var qs = require('qs');
    new HttpClient(false).post("b2c/recover-password", qs.stringify({ email: email }), config)
        .then((response) => {
            dispatch({ type: SHOW_SUCCESSFUL_MESSAGE, payload: "Un correo electrónico ha sido enviado para restablecer su contraseña." });
            history.replace(NOT_AUTHENTICATED_HOME);
        })
        .catch((error) => {
            dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
        })
}

export const changePassword = (data) => dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    new HttpClient(true).post("b2c/change-password", data, config)
        .then((response) => {
            dispatch({ type: SHOW_SUCCESSFUL_MESSAGE, payload: "Contraseña cambiada correctamente." });
        })
        .catch((error) => {
            dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
        })
}


// WEBPACK FOOTER //
// ./src/reducers/user/userActions.js